// extracted by mini-css-extract-plugin
module.exports = {"rootinner":"kolpop_rootinner_3ASqK","bg":"kolpop_bg_1Vvv9","text":"kolpop_text_UEf2e","btn":"kolpop_btn_1TWwR"};